import { AbstractControl, FormControl, Validators, FormArray, FormGroup } from '@angular/forms';

export class SmsTemplate {
    public static validation(profile = false): { [key: string]: AbstractControl } {
        let validator: { [key: string]: AbstractControl } = {
            temp_type: new FormControl('', Validators.required),
            description: new FormControl('', Validators.required),
        };
        return validator;
    }

    public static readonly validationMessages = {
        'temp_type': [{ type: 'required', message: 'Obbligatorio' }],
        'description': [{ type: 'required', message: 'Obbligatorio' }]
    };

    constructor(
        public id?: number,
        public temp_type?: string,
        public description?: string,
    ) { }
}